export default function Footer() {
  const navSections = [
    {
      title: '热门内容',
      links: [
        { label: '麻豆精品', href: '#cards' },
        { label: '九色系列', href: '#cards' },
        { label: '国产剧大全', href: '#index' },
        { label: '高清电影', href: '#index' },
      ],
    },
    {
      title: '快捷入口',
      links: [
        { label: '影视热榜', href: '#ranking' },
        { label: '焦点专题', href: '#carousel' },
        { label: '常见问题', href: '#faq' },
        { label: '热门话题', href: '#topics' },
      ],
    },
    {
      title: '关于平台',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '联系我们', href: '#contact' },
        { label: '最新动态', href: '#updates' },
        { label: 'APP下载', href: '#app' },
      ],
    },
  ];

  return (
    <footer id="footer" className="w-full bg-primary-900 text-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <a href="#" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                91
              </span>
              <span className="text-lg font-heading font-bold text-background-50">
                91免费在线视频
              </span>
            </a>
            <p className="text-sm text-background-50/60 leading-relaxed mb-4">
              全网最全的高清影视平台，提供海量国产精品视频在线观看、最新热门影片免费追剧，麻豆系列独家资源一站看尽。
            </p>
          </div>

          {navSections.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-50/50 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10">
          <h4 className="text-sm font-semibold text-background-50 mb-4">
            合作伙伴
          </h4>
          <div className="flex flex-wrap gap-4 mb-8">
            <span className="text-sm text-background-50/30">更多合作伙伴即将入驻</span>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; 2016-2026 91免费在线视频 版权所有。本站内容仅供学习交流，请支持正版影视。
            </p>
            <div className="flex items-center gap-4">
              <a href="#about" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">
                关于我们
              </a>
              <a href="#faq" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">
                常见问题
              </a>
              <a href="#contact" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">
                联系我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}